import { type OrderItemEntity, type OrderItemListingEntity, type SaleReferenceDto, type ValueAddedServiceCode } from '~/apiClient';

export type SaleOrderItemEntity = Omit<OrderItemEntity, 'saleReference'> & {
    saleReference: SaleReferenceDto;
};

export function isSaleOrderItemEntity(orderItem: OrderItemEntity): orderItem is SaleOrderItemEntity {
    return !!orderItem.saleReference;
}

export type SaleOrderItemListingEntity = Omit<OrderItemListingEntity, 'saleReference'> & {
    saleReference: SaleReferenceDto;
};

export function isSaleOrderItemListingEntity(orderItem: OrderItemListingEntity): orderItem is SaleOrderItemListingEntity {
    return !!orderItem.saleReference;
}

export type VasOrderItemEntity = Omit<OrderItemEntity, 'valueAddedServiceCode'> & {
    valueAddedServiceCode: ValueAddedServiceCode;
};

export function isVasOrderItemEntity(orderItem: OrderItemEntity): orderItem is VasOrderItemEntity {
    return !!orderItem.valueAddedServiceCode;
}

export type VasOrderItemListingEntity = Omit<OrderItemListingEntity, 'valueAddedServiceCode'> & {
    valueAddedServiceCode: ValueAddedServiceCode;
};

export function isVasOrderItemListingEntity(orderItem: OrderItemListingEntity): orderItem is VasOrderItemListingEntity {
    return !!orderItem.valueAddedServiceCode;
}
